import { NavigationItem } from '@scale/scaleui';
import React from 'react';
import { Link, matchPath, useLocation } from 'react-router-dom';

import { TeamLeadPermissionRole } from '@scale/shared/types/expertManagement';
import { useCanUserModifyCommunity } from 'react-scale/components/ExpertManagement/hooks/useCanUserModifyCommunity';
import { useIsCurrentUserAuthorized } from 'react-scale/components/ExpertManagement/hooks/useIsCurrentUserAuthorized';
import { Routes } from 'react-scale/components/ExpertManagement/urls';
import { useRemoAdminCtx } from 'react-scale/components/remoAdmin/remoAdminContext';
import useQueryParams from 'react-scale/corp/hooks/useQueryParams';
import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';

export const ExpertManagementNavigation: React.FC<{ sidebarOpen: boolean }> = ({ sidebarOpen }) => {
  const isSuperAdmin = useIsCurrentUserAuthorized([TeamLeadPermissionRole.SuperAdmin]);
  const useNewSquadManagementUI = useUnleashFeatureFlag('squad-management-new-ui', {}, false);
  const canModify = useCanUserModifyCommunity() && useNewSquadManagementUI;
  const { pathname } = useLocation();
  const params = useQueryParams();
  const { isRemoAdmin } = useRemoAdminCtx();
  return (
    <nav className="px-2 pb-4 mt-4 space-y-1">
      <div className="cursor-pointer">
        <Link to={Routes.ExpertManagement}>
          <NavigationItem
            isCollapsed={!sidebarOpen}
            name="Overview"
            icon="users"
            current={
              !!matchPath(pathname, {
                path: Routes.ExpertManagement,
                exact: true,
              }) && !params.mode
            }
          />
        </Link>
        {canModify && (
          <Link to={!isRemoAdmin ? Routes.Community : '?mode=community'}>
            <NavigationItem
              isCollapsed={!sidebarOpen}
              name="Community Management"
              icon="people-arrows"
              current={
                !!matchPath(pathname, {
                  path: Routes.Community,
                }) || params.mode === 'community'
              }
            />
          </Link>
        )}
        {!isRemoAdmin && isSuperAdmin && (
          <Link to={Routes.WebinarSessions}>
            <NavigationItem
              isCollapsed={!sidebarOpen}
              name="Webinar Sessions"
              icon="laptop"
              current={
                !!matchPath(pathname, {
                  path: Routes.WebinarSessions,
                })
              }
            />
          </Link>
        )}
        {!isRemoAdmin && isSuperAdmin && (
          <Link to={Routes.Admin}>
            <NavigationItem
              isCollapsed={!sidebarOpen}
              name="Admin"
              icon="cog"
              current={
                !!matchPath(pathname, {
                  path: Routes.Admin,
                })
              }
            />
          </Link>
        )}
      </div>
    </nav>
  );
};
